import { Guid } from "guid-typescript";
import {
  FrameMessage,
  FrameMessageType,
  IActionDefinitionDto,
  IAddChildItemMessage,
  IChangeDashboardStateMessage,
  ICloneItemMessage,
  ICopyItemMessage,
  IDetachFormMessage,
  IDragDropByCreateItemMessage,
  IDragDropByMoveItemMessage,
  IExceptionHandlingMessage,
  IMergeStaticTableColumnsMessage,
  IPasteItemMessage,
  IPropertyChangedMessage,
  IRemoveItemMessage,
  ISelectItemMessage,
  IShowFormPopupMessage,
  IShowWorkflowBusinessObjectPopupMessage
} from "../../index";
import { IInjectDisplayItemToTargetDisplayItemMessage } from "../messages/designer-messages/inject-display-item-to-target-display-item-message";
import { IChangePositionMessage } from "../messages/frame-messages/change-position-message";
import { IPasteItemStyleMessage } from "../messages/frame-messages/paste-item-style-message";
import { ISaveBlockAsCustomBlockMessage } from "../messages/frame-messages/save-block-as-custom-block-message";
import { ISelectionGeometryMessage } from "../messages/frame-messages/selection-geometry-message";
import { IShowActionPopupMessage } from "../messages/frame-messages/show-action-popup-message";

declare let window: any;

export class FrameMessageSender {
  static instance: FrameMessageSender;

  static getInstance() {
    if (!FrameMessageSender.instance) {
      FrameMessageSender.instance = new FrameMessageSender();
    }
    return FrameMessageSender.instance;
  }

  send = (messageType: FrameMessageType, message?: FrameMessage) => {
    const messageId: string = Guid.create().toString();
    // console.log(">>>>>> Sent Message From Frame To Designer (" + FrameMessageType[messageType].toString()+", Message ID:"  + messageId + ", " + new Date().getSeconds() + "-" + new Date().getMilliseconds() + " )");
    // console.log(message);
    // console.log(">>>>>>");
    if (!message || !messageType) {
      return;
    }
    const event = {
      iframeMessage: { messageType, message, messageId }
    };
    window.parent.window.postMessage(event, "*");
  };

  selectItemMessage = (message: ISelectItemMessage) => {
    this.send(FrameMessageType.selectItemMessage, message);
  };

  cloneItemMessage = (message: ICloneItemMessage) => {
    this.send(FrameMessageType.cloneItemMessage, message);
  };

  dragDropByCreateItemMessage = (message: IDragDropByCreateItemMessage) => {
    this.send(FrameMessageType.dragDropByCreateItemMessage, message);
  };

  injectDisplayItemToTargetDisplayItemMessage = (message: IInjectDisplayItemToTargetDisplayItemMessage) => {
    this.send(FrameMessageType.injectDisplayItemToTargetDisplayItemMessage, message);
  };

  replaceDisplayItemToTargetDisplayItemMessage = (message: IInjectDisplayItemToTargetDisplayItemMessage) => {
    this.send(FrameMessageType.replaceDisplayItemToTargetDisplayItemMessage, message);
  };

  dragDropByMoveItemMessage = (message: IDragDropByMoveItemMessage) => {
    this.send(FrameMessageType.dragDropByMoveItemMessage, message);
  };

  addChildItemMessage = (message: IAddChildItemMessage) => {
    this.send(FrameMessageType.addChildItemMessage, message);
  };

  exceptionHandlingMessage = (message: IExceptionHandlingMessage) => {
    this.send(FrameMessageType.exceptionHandlingMessage, message);
  };

  removeItemMessage = (message: IRemoveItemMessage) => {
    this.send(FrameMessageType.removeItemMessage, message);
  };

  changePositionMessage = (message: IChangePositionMessage) => {
    this.send(FrameMessageType.changePositionMessage, message);
  };

  propertyChangedMessage = (message: IPropertyChangedMessage) => {
    this.send(FrameMessageType.propertyChangedMessage, message);
  };

  copyItemMessage = (message: ICopyItemMessage) => {
    this.send(FrameMessageType.copyItemMessage, message);
  };

  pasteItemMessage = (message: IPasteItemMessage) => {
    this.send(FrameMessageType.pasteItemMessage, message);
  };

  pasteItemStyleMessage = (message: IPasteItemStyleMessage) => {
    this.send(FrameMessageType.pasteItemStyleMessage, message);
  };

  getClipboardValue = () => {
    this.send(FrameMessageType.getClipboardValue);
  };

  undoMessage = (message: any) => {
    this.send(FrameMessageType.undoMessage, message);
  };

  redoMessage = (message: any) => {
    this.send(FrameMessageType.redoMessage, message);
  };

  saveScreenMessage = (message: any) => {
    this.send(FrameMessageType.saveScreenMessage, message);
  };

  changeDashboardStateMessage = (message: IChangeDashboardStateMessage) => {
    this.send(FrameMessageType.changeDashboardStateMessage, message);
  };

  setNewScreenModalVisibilityMessage = (message?: any) => {
    this.send(FrameMessageType.setNewScreenModalVisibilityMessage, message);
  };

  setActiveLeftPanelByClickMessage = (message?: any) => {
    this.send(FrameMessageType.setActiveLeftPanelByClickMessage, message);
  };

  setActiveRightPanelByClickMessage = (message?: any) => {
    this.send(FrameMessageType.setActiveRightPanelByClickMessage, message);
  };

  showActionPopup = (targetKuikaId: string, actionDefinition: IActionDefinitionDto): void => {
    const message: IShowActionPopupMessage = { targetKuikaId, actionDefinition };
    this.send(FrameMessageType.showActionPopup, message);
  };

  showWorkflowBusinessObjectPopup = (targetKuikaId: string, processId: string) => {
    const message: IShowWorkflowBusinessObjectPopupMessage = {
      processId,
      targetKuikaId
    };
    this.send(FrameMessageType.showWorkflowBusinessObjectPopup, message);
  };

  showFormPopup = (targetKuikaId: string) => {
    const message: IShowFormPopupMessage = { targetKuikaId };
    this.send(FrameMessageType.showFormPopup, message);
  };

  detachFormMessage = (targetKuikaId: string) => {
    const message: IDetachFormMessage = { targetKuikaId };
    this.send(FrameMessageType.detachFormMessage, message);
  };

  mergeStaticTableColumnsMessage = (message: IMergeStaticTableColumnsMessage) => {
    this.send(FrameMessageType.mergeStaticTableColumnsMessage, message);
  };

  saveBlockAsCustomBlockMessage = (message: ISaveBlockAsCustomBlockMessage) => {
    this.send(FrameMessageType.saveBlockAsCustomBlockMessage, message);
  };

  selectionGeometryMessage = (message: ISelectionGeometryMessage) => {
    this.send(FrameMessageType.selectionGeometryMessage, message);
  };
}
